import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TabsModule } from 'ngx-bootstrap/tabs';
import type { Field } from 'src/app/modules/dynamic-form-builder/model/formBuilderInterface';

@Component({
  selector: 'app-tab-view',
  templateUrl: './tab-view.component.html',
  styleUrls: ['./tab-view.component.scss'],
  standalone: true,
  imports: [TabsModule, CommonModule, ReactiveFormsModule]
})
export class TabViewComponent {
  @Input() field: Field;
  @Input() form: FormGroup;
  @Output() tabChanged = new EventEmitter<string>();

  changeMessageTab(tabKey: string) {
    this.tabChanged.emit(tabKey);
  }
}
